import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loginWithMagicURL } from "../service/auth";

function Confirm() {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		try {
			const urlParams = new URLSearchParams(location.search);
			const userId = urlParams.get("userId");
			const secret = urlParams.get("secret");
			console.log(userId, secret);
			loginWithMagicURL(userId, secret)
				.then((user) => {
					console.log(user, "logged in");
					navigate("/dashboard");
				})
				.catch((e) => {
					console.log(e);
					navigate("/");
				});
		} catch (error) {
			console.log("error in", error);
			navigate("/");
		}
	}, []);
	return <div></div>;
}

export default Confirm;
